import React from 'react';
import ShowToast from '@ingka/toast';
import { Toast } from '../contexts/Toast';
import { noop } from '../types/common';

interface ShowToastItemProps {
  toast?: Toast;
  onClose: () => void;
}
export const ShowToastItem: React.FC<ShowToastItemProps> = ({
  toast,
  onClose,
}): JSX.Element | null => {
  const { text = '', buttonText = '', action = noop } = toast || {};
  return (
    <ShowToast
      text={text}
      actionButtonText={buttonText}
      actionClick={action}
      onCloseRequest={onClose}
      onTransitionEnd={(): void => {
        // TODO: Remove once bug from component is gone. If omitted an exception will be thrown.
      }}
      aria-live="polite"
      role="alertdialog"
      isOpen={!!text}
    />
  );
};
